import React from 'react';

import {
  Input,
  Tooltip,
  Button,
  DatePicker,
  InputNumber,
  Select,
  Radio,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import getSucursales from '../../../graphql/querys/organismos/getSucursales.graphql';

const FormItem = Form.Item;
const Option = Select.Option;
const { RangePicker } = DatePicker;

@compose(
  graphql(getUsuario),
  graphql(getSucursales, { name: 'getSucursales' }),
  graphql(getOrganismos, { name: 'getOrganismos' })
)
class FormDeposito extends React.Component {
  onSubmit = e => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let fecha = values.fecha.toDate();
        values.fecha = fecha;
        values.fechaPeriodoInicio = values.fechaRango[0].toDate();
        values.fechaPeriodoFin = values.fechaRango[1].toDate();
        delete values.fechaRango;
        this.props.onSubmit(values);
      }
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('HOLA: ', nextProps);
    if (!nextProps.data.loading && nextProps.data.getUsuario) {
      // console.log('Entre con: ', nextProps.data.getUsuario);
      this.cambiarOrganismo(nextProps.data.getUsuario.organismo._id);
    }
  }

  // eslint-disable-next-line no-unused-vars
  onChange = (date, dateString) => {
    this.setState({
      ...this.state,
      fechaInicio: date[0]
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .toDate(),
      fechaFin: date[1]
        .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
        .toDate(),
    });
  };

  checkNumero = (rule, value, callback) => {
    var bool = /^[0-9]*$/.test(value);
    if (bool) {
      callback();
    } else {
      callback('El numero es unicamente con numeros, sin puntos');
    }
  };

  cambiarOrganismo = idOrganismo => {
    this.setState({
      ...this.state,
      idOrganismo: idOrganismo,
      nombreOrganismo: this.obtenerNombreOrganismo(idOrganismo),
    });
  };

  crearOpciones(sucursal) {
    return (
      <Option key={sucursal._id} value={sucursal._id}>
        {sucursal.nombre}
      </Option>
    );
  }

  onChangeTipo = e => {
    console.log('radio checked', e.target.value);
    this.setState(
      {
        ...this.state,
        tipo: e.target.value,
      },
      () => {
        console.info('<--this.state-->');
        console.log(this.state);
        console.info('<--/this.state-->');
      }
    );
  };

  obtenerNombreOrganismo = idOrganismo => {
    let nombre = '';
    let organismo = _.find(this.props.getOrganismos.getOrganismos, {
      _id: idOrganismo,
    });
    organismo
      ? (nombre = organismo.nombre)
      : (nombre = this.props.data.getUsuario.organismo.nombre);
    return nombre;
  };

  render() {
    // console.log('render');
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const { getFieldDecorator } = this.props.form;

    const { data } = this.props;
    if (data.loading) {
      return <Loading />;
    }

    if (!data.getUsuario || !this.props.getOrganismos.getOrganismos) {
      return <Loading />;
    }

    let usuario = this.props.data.getUsuario;

    let listaSucursales = this.props.getSucursales.getSucursales;
    if (listaSucursales) {
      var opciones = _.map(listaSucursales, this.crearOpciones);
    }

    console.log(this.props.form.getFieldValue('tipo'));

    return (
      <div>
        <h3 className="tituloForm">Datos del Deposito</h3>

        <Form
          onSubmit={this.onSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Organismo
                <Tooltip title="Seleccione el organismo del reporte">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('idOrganismo', {
              initialValue: usuario.organismo._id,
              rules: [
                {
                  type: 'string',
                  required: true,
                  message: 'Por favor, seleccione el organismo del deposito',
                },
              ],
            })(
              <Select
                style={{ width: 400, marginRight: 20 }}
                id="organismos"
                placeholder="Seleccione el organismo"
                // defaultValue={usuario.organismo._id}
                disabled={usuario.organismo._id != '00004'}
                onSelect={valor => this.cambiarOrganismo(valor)}
              >
                {this.props.getOrganismos.getOrganismos &&
                  this.props.getOrganismos.getOrganismos.map(organismo => (
                    <Select.Option key={organismo._id}>
                      {organismo.nombre}
                    </Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Fecha de la operación
                <Tooltip title="Seleccione la fecha de que se efectuó el deposito">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('fecha', {
              rules: [
                {
                  type: 'object',
                  required: true,
                  message: 'Por favor, seleccione la fecha del de deposito',
                },
              ],
            })(
              <DatePicker
                style={{ width: 400 }}
                placeholder="Fecha del deposito"
                format="DD/MM/YYYY"
              />
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Rango que comprende el dinero de la operacion
                <Tooltip title="A que periodo de fechas corresponde el dinero del deposito">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('fechaRango')(
              <RangePicker
                style={{ width: 400 }}
                onChange={this.onChange}
                format={'DD-MM-YYYY'}
              />
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Tipo
                <Tooltip title="Seleccione si es un Deposito Bancario o Transferencia">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('tipo', {
              rules: [
                {
                  type: 'string',
                  required: true,
                  message: 'Por favor, seleccione el tipo de operación',
                },
              ],
            })(
              <Radio.Group onChange={this.onChangeTipo}>
                <Radio value={'deposito'}>Deposito Bancario</Radio>
                <Radio value={'transferencia'}>Transferencia</Radio>
              </Radio.Group>
            )}
          </FormItem>

          {this.props.form.getFieldValue('tipo') === 'deposito' && (
            <FormItem
              {...formItemLayout}
              label={
                <span>
                  Nombre de la Sucursal
                  <Tooltip title="Nombre de la Sucursal del BPN donde se depositó">
                    <Icons.QuestionCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              {getFieldDecorator('idSucursal', {
                rules: [
                  {
                    required:
                      this.props.form.getFieldValue('tipo') === 'deposito',
                    message: 'Por favor, ingresar el nombre de la sucursal!',
                    whitespace: true,
                  },
                ],
              })(
                <Select
                  showSearch
                  style={{ width: 400, marginRight: 20 }}
                  placeholder="Seleccione una sucursal"
                  optionFilterProp="children"
                  onChange={this.handleChange}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {opciones}
                </Select>
              )}
            </FormItem>
          )}

          {this.props.form.getFieldValue('tipo') === 'transferencia' && (
            <FormItem
              {...formItemLayout}
              label={
                <span>
                  Nombre del Banco
                  <Tooltip title="Nombre del Banco">
                    <Icons.QuestionCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              {getFieldDecorator('nombreBancoTransferencia', {
                rules: [
                  {
                    required:
                      this.props.form.getFieldValue('tipo') === 'transferencia',
                    message: 'Por favor, ingresar el nombre del banco!',
                    whitespace: true,
                  },
                ],
              })(<Input style={{ width: 400 }} />)}
            </FormItem>
          )}

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Numero de Referencia
                <Tooltip title="Numero que aparece en el comprobante del deposito">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('numBoletaDeposito', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar el numero de referencia!',
                },
              ],
            })(<Input style={{ width: 400 }} />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Importe total
                <Tooltip title="Importe que aparece en el comprobante del deposito">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('importe', {
              rules: [
                {
                  required: true,
                  message:
                    'Por favor, ingresar el numero de forma correcta, sin puntos!',
                  validator: this.checkNumero,
                },
              ],
            })(<InputNumber style={{ width: 400 }} />)}
            <span className="ant-form-text"> $</span>
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginLeft: '25%' }}
            >
              Confirmar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    moment.locale();
    return {
      fecha: Form.createFormField({
        value:
          props.datos && props.datos.fecha
            ? moment(new Date(props.datos.fecha), 'DD/MM/YYYY')
            : moment(),
      }),
      idSucursal: Form.createFormField({
        value:
          props.datos && props.datos.sucursal ? props.datos.sucursal._id : '',
      }),
      numBoletaDeposito: Form.createFormField({
        value: props.datos ? props.datos.numBoletaDeposito : '',
      }),
      importe: Form.createFormField({
        value: props.datos ? props.datos.importe : '',
      }),
    };
  },
})(withApollo(FormDeposito));
